import { NamedError } from "../../utils/Errors";

export class IncorrectStorageSchemaError extends NamedError<InCorrectStorageSchemaErrorName> {

}

export enum InCorrectStorageSchemaErrorName {
    InvalidWithIStoredTranscriptionArraySchema = 'InvalidWithIStoredTranscriptionArraySchema',
    InvalidWithIStoredTranscriptionSchema = 'InvalidWithIStoredTranscriptionSchema'
}